<template>
  <div>
    <div class="panel-header">
      <span class="panel-bar"></span>
      <span class="panel-title">个人简历</span>
    </div>

    <div class="resume-page">
      <!-- ========== 工作经历 ========== -->
      <section class="section">
        <div class="section-head">
          <div class="section-left">
            <div class="section-title">工作经历</div>
            <span class="badge">必填</span>
          </div>

          <div>
            <!-- 编辑态：添加工作履历（只清空工作表单） -->
            <div v-if="mode === 'edit'" class="section-button2" @click="addWork()">
              <img class="meta-icon" src="@/assets/add2.png" alt="" />添加工作履历
            </div>

            <!-- 展示态：添加工作履历 => 进入编辑态（保留历史工作经历；清空其它表单内容） -->
            <div v-if="mode === 'view'" class="section-button" @click="enterEditFromAddWork()">
              <img class="meta-icon" src="@/assets/add.png" alt="" />添加工作履历
            </div>
          </div>
        </div>

        <!-- 编辑态：顶部编辑框（新增工作履历表单） -->
        <div v-if="mode === 'edit'" class="edit-card">
          <div class="edit-form">
            <div class="f-row">
              <div class="f-label">公司名称：</div>
              <div class="f-control">
                <el-input v-model="draft.workForm.company" placeholder="请输入公司名称" />
              </div>
            </div>

            <div class="f-row">
              <div class="f-label">工作时间：</div>
              <div class="f-control f-control-inline">
                <el-date-picker v-model="draft.workForm.start" type="month" placeholder="入职时间" class="picker" />
                <el-date-picker v-model="draft.workForm.end" type="month" placeholder="离职时间" class="picker"
                  :disabled="draft.workForm.isNow" />
                <label class="checkbox">
                  <input type="checkbox" v-model="draft.workForm.isNow" />
                  至今
                </label>
              </div>
            </div>

            <div class="f-row">
              <div class="f-label">职位描述：</div>
              <div class="f-control">
                <el-input v-model="draft.workForm.position" placeholder="请输入" />
              </div>
            </div>

            <div class="f-row">
              <div class="f-label">工作描述：</div>
              <div class="f-control">
                <el-input v-model="draft.workForm.description" type="textarea" :rows="5" placeholder="请输入" />
                <div class="counter">还可输入1000个字</div>
              </div>
            </div>

            <div class="form-actions" style="padding-bottom: 28px;">
              <el-button class="primary-btn" type="success" @click="saveWorkToList()">
                保存并更新
              </el-button>
              <span @click="resetWorkForm()" style="font-size: 14px; color: #999999; cursor: pointer;">取消</span>
            </div>
          </div>
        </div>

        <!-- 列表：展示态与编辑态都显示 -->
        <div class="timeline">
          <div v-for="(item, idx) in draft.workList" :key="idx" class="tl-item">
            <div class="tl-time">{{ formatRange(item.start, item.end, item.isNow) }}</div>
            <div class="tl-content">
              <div class="tl-title">
                <span class="tl-position">{{ item.position }}</span>
              </div>
              <div class="tl-sub">{{ item.company }}</div>
              <div class="tl-desc">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </section>

      <!-- ========== 学校 ========== -->
      <section class="section">
        <div class="section-head">
          <div class="section-left">
            <div class="section-title">学校</div>
            <span class="badge">必填</span>
          </div>
          <div class="section-actions">
            <button v-if="mode === 'view'" class="mini-link" type="button" @click="enterEdit()">
              修改
            </button>
          </div>
        </div>

        <div :class="['block', mode === 'edit' ? 'block-edit-bg' : '']">
          <div v-if="mode === 'view'" class="kv">
            <div class="k">学校名称：</div>
            <div class="v" style="color: #333333; margin-left: 30px;">{{ draft.schoolName || '-' }}</div>
          </div>

          <div v-else class="edit-lite">
            <div class="f-row">
              <div class="f-label">学校名称：</div>
              <div class="f-control">
                <el-input v-model="draft.schoolName" placeholder="请输入学校名称" />
              </div>
            </div>

            <div class="form-actions compact">
              <el-button class="primary-btn small" type="success" @click="saveAll()">保存</el-button>
              <span class="cancel-text" @click="cancelEdit()">取消</span>
            </div>
          </div>
        </div>
      </section>

      <!-- ========== 技能 ========== -->
      <section class="section">
        <div class="section-head">
          <div class="section-left">
            <div class="section-title">技能</div>
            <span class="badge">非必填</span>
          </div>
          <div class="section-actions">
            <button v-if="mode === 'view'" class="mini-link" type="button" @click="enterEdit()">
              修改
            </button>
          </div>
        </div>

        <div :class="['block', mode === 'edit' ? 'block-edit-bg' : '']">
          <div v-if="mode === 'view'" class="tags">
            <span v-for="(t, i) in draft.skills" :key="i" class="tag">{{ t }}</span>
            <span v-if="!draft.skills.length" class="muted">-</span>
          </div>

          <div v-else >
            <!-- ✅ 图二样式：技能标签（浅绿 + X） -->
            <div class="skill-selected-row">
              <div class="skill-selected-label">技能标签：</div>
              <div>
                <div class="skill-selected">
                <span v-for="(t, i) in draft.skills" :key="t + '-' + i" class="skill-chip">
                  <span class="skill-chip-text">{{ t }}</span>
                  <img src="@/assets/Outlinex.png" class="slashlogo" alt="" />
                </span>

              </div>
              <div class="skill-selected" style="margin-top: 28px;"> <span v-for="(t, i) in draft.allTags" :key="t + '-' + i" class="skill-chip2">
                  <span class="skill-chip-text">{{ t }}</span>
                </span></div>
              </div>
         
            </div>

            <div class="form-actions compact">
              <el-button class="primary-btn small" type="success" @click="saveAll()">保存</el-button>
              <span class="cancel-text" @click="cancelEdit()">取消</span>
            </div>
          </div>
        </div>
      </section>

      <!-- ========== 个人信息 ========== -->
      <section class="section">
        <div class="section-head">
          <div class="section-left">
            <div class="section-title">个人信息</div>
            <span class="badge">必填</span>
          </div>
          <div class="section-actions">
            <button v-if="mode === 'view'" class="mini-link" type="button" @click="enterEdit()">
              修改
            </button>
          </div>
        </div>

        <div :class="['block', mode === 'edit' ? 'block-edit-bg' : '']">
          <div v-if="mode === 'view'" class="kv-list">
            <div class="kv">
              <div class="k" >每小时薪酬：</div>
              <div class="v">{{ draft.hourlyRate ? `${draft.hourlyRate}元` : '-' }}</div>
            </div>
            <div class="kv">
              <div class="k">手机号：</div>
              <div class="v">{{ draft.mobile || '-' }}</div>
            </div>
            <div class="kv">
              <div class="k">微信号：</div>
              <div class="v">{{ draft.wechat || '-' }}</div>
            </div>
          </div>

          <div v-else class="edit-lite">
            <div class="f-row">
              <div class="f-label" style="width: 100px;">每小时薪酬：</div>
              <div class="f-control">
                <el-input v-model="draft.hourlyRate" placeholder="请输入" />
              </div>
            </div>
            <div class="f-row">
              <div class="f-label">手机号：</div>
              <div class="f-control">
                <el-input v-model="draft.mobile" placeholder="请输入" />
              </div>
            </div>
            <div class="f-row">
              <div class="f-label">微信号：</div>
              <div class="f-control">
                <el-input v-model="draft.wechat" placeholder="请输入" />
              </div>
            </div>

            <div class="form-actions compact">
              <el-button class="primary-btn small" type="success" @click="saveAll()">保存</el-button>
              <span class="cancel-text" @click="cancelEdit()">取消</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'

const mode = ref('view') // 'view' | 'edit'

const source = reactive({
  workList: [
    {
      start: '2024',
      end: '',
      isNow: true,
      position: 'UI设计师/产品',
      company: 'XXXXXX科技有限公司',
      description:
        '与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。'
    },
    {
      start: '2022',
      end: '2024',
      isNow: false,
      position: 'UI设计师/产品',
      company: 'XXXXXX科技有限公司',
      description:
        '与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。'
    },
    {
      start: '2020',
      end: '2022',
      isNow: false,
      position: 'UI设计师/产品',
      company: 'XXXXXX科技有限公司',
      description:
        '与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。'
    },
  ],
  schoolName: '华东政法大学',
  skills: ['Axure', 'Sketch', 'XD', 'Figma', '界面设计'],
  allTags: ['标签1', '标签1', '标签1', '标签1', '标签1', '标签1', '标签1', '标签1111', '标签11111', '标签111111'],
  hourlyRate: '100',
  mobile: '150****12345678',
  wechat: 'wxid123456789',
})

const draft = reactive({
  workList: [],
  schoolName: '',
  skills: [],
  allTags: [],
  skillInput: '',
  hourlyRate: '',
  mobile: '',
  wechat: '',
  workForm: {
    company: '',
    start: '',
    end: '',
    isNow: false,
    position: '',
    description: '',
  },
})

/** 带出全部历史数据（用于“修改”） */
function cloneFromSource() {
  draft.workList = JSON.parse(JSON.stringify(source.workList))
  draft.schoolName = source.schoolName
  draft.skills = JSON.parse(JSON.stringify(source.skills))
  draft.allTags = JSON.parse(JSON.stringify(source.allTags)) 
  draft.skillInput = ''
  draft.hourlyRate = source.hourlyRate
  draft.mobile = source.mobile
  draft.wechat = source.wechat
  resetWorkForm()
}

/** 只保留历史工作经历列表（用于“添加工作履历”入口） */
function cloneWorkListOnly() {
  draft.workList = JSON.parse(JSON.stringify(source.workList))
}

/** ✅ 展示态点击“添加工作履历”进入编辑：
 * - 保留历史工作经历（workList）
 * - 清空：workForm / schoolName / 个人信息
 * - ✅ 技能不清空（否则标签丢失）
 */
function enterEditFromAddWork() {
  cloneWorkListOnly()
  resetWorkForm()

  // 清空学校
  draft.schoolName = ''

  // ✅ 技能保留（图二编辑态要显示已选标签）
  draft.skills = JSON.parse(JSON.stringify(source.skills))
  draft.allTags = JSON.parse(JSON.stringify(source.allTags)) 
  draft.skillInput = ''

  // 清空个人信息
  draft.hourlyRate = ''
  draft.mobile = ''
  draft.wechat = ''

  mode.value = 'edit'
}

/** 点击“修改”进入编辑：带出全部原数据 */
function enterEdit() {
  cloneFromSource()
  mode.value = 'edit'
}

function cancelEdit() {
  mode.value = 'view'
}

/** 保存：把 draft 写回 source */
function saveAll() {
  source.workList = JSON.parse(JSON.stringify(draft.workList))
  source.schoolName = draft.schoolName
  source.skills = JSON.parse(JSON.stringify(draft.skills))
  source.hourlyRate = draft.hourlyRate
  source.mobile = draft.mobile
  source.wechat = draft.wechat
  mode.value = 'view'
}

/* 工作经历 */
function addWork() {
  resetWorkForm()
}

function resetWorkForm() {
  draft.workForm = {
    company: '',
    start: '',
    end: '',
    isNow: false,
    position: '',
    description: '',
  }
}

function saveWorkToList() {
  const f = draft.workForm
  if (!f.company || !f.position) return

  draft.workList.unshift({
    company: f.company,
    start: f.start || '',
    end: f.isNow ? '' : (f.end || ''),
    isNow: !!f.isNow,
    position: f.position,
    description: f.description || '',
  })

  resetWorkForm()
}
function formatRange(start, end, isNow) {
  const s = start ? String(start).replace('-', '.') : ''
  if (isNow) return `${s} — Now`
  const e = end ? String(end).replace('-', '.') : ''
  return `${s} — ${e || ''}`.trim()
}

/* 勾选“至今”时清空离职时间 */
watch(
  () => draft.workForm.isNow,
  (v) => {
    if (v) draft.workForm.end = ''
  }
)

// 初始化展示态数据（展示用：用 source 填充 draft）
cloneFromSource()
mode.value = 'view'
</script>

<style scoped lang="scss">
:deep(.el-input) {
  height: 40px;
}

:deep(.el-input__wrapper) {
  border-radius: 4px;
}

:deep(.el-textarea__inner) {
  border-radius: 4px;
}

.panel-header {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 50px;
}

.panel-bar {
  width: 3px;
  height: 16px;
  border-radius: 2px;
  background: #4CAF50;
}

.panel-title {
  font-weight: 500;
  font-size: 18px;
  color: #495060;
}

.resume-page {
  padding-left: 22px;
  max-width: 980px;
}

.section {
  margin-bottom: 26px;
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
}

.section-left {
  display: flex;
  align-items: center;
  gap: 4px;
}

.section-title {
  font-weight: 400;
  font-size: 18px;
  color: #303133;
}

.badge {
  width: 40px;
  height: 17px;
  background: #EF7C67;
  border-radius: 2px;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-button2 {
  display: flex;
  align-items: center;
  padding: 2px 12px;
  gap: 6px;
  height: 28px;
  background: #4CAF50;
  border-radius: 20px;
  border: 1px solid #4CAF50;
  font-weight: 400;
  font-size: 14px;
  color: #fff;
  cursor: pointer;

  .meta-icon {
    width: 16px;
    height: 16px;
  }
}

.section-button {
  display: flex;
  align-items: center;
  padding: 2px 12px;
  gap: 6px;
  height: 28px;
  border-radius: 20px;
  border: 1px solid #F2F2F2;
  font-weight: 400;
  font-size: 14px;
  color: #303133;
  cursor: pointer;

  .meta-icon {
    width: 16px;
    height: 16px;
  }
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mini-link {
  border: none;
  background: transparent;
  cursor: pointer;
  font-weight: 400;
  font-size: 16px;
  color: #4CAF50;
}

.mini-link:hover {
  text-decoration: underline;
}

.block {
  margin-left: 48px;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}

/* 编辑态背景块（学校/技能/个人信息） */
.block-edit-bg {
  background: #F7F7F7;
  border-radius: 4px;
  padding: 22px 24px;
}

.edit-card {
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 18px;
  margin-bottom: 24px;
}

.edit-form {
  max-width: 740px;
}

.f-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}

.f-label {
  width: 100px;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  padding-top: 9px;
}

.f-control {
  flex: 1;
}

.f-control-inline {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.picker {
  width: 170px;
}

.checkbox {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #606266;
}

.counter {
  font-size: 12px;
  color: #999999;
  text-align: right;
}

.form-actions {
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 56px;
  margin-left: 92px;
}

.form-actions.compact {
  margin-top: 24px;
  margin-left: 92px;
  gap: 24px;
}

.cancel-text {
  font-size: 14px;
  color: #999999;
  cursor: pointer;
}

.cancel-text:hover {
  text-decoration: underline;
}

.primary-btn {
  padding: 0 24px;
  height: 30px;
  background: #4CAF50;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
}

.timeline {
  display: flex;
  flex-direction: column;
  // margin-left: 48px;
}

.tl-item {
  display: flex;
  align-items: flex-start;
  position: relative;
}

.tl-time {
  width: 130px;
  color: #8a8f98;
  font-size: 12px;
  padding-top: 2px;
}

.tl-content {
  flex: 1;
  background: #fff;
  border-radius: 4px;
}

.tl-position {
  font-weight: 700;
  font-size: 13px;
  color: #2b2f33;
}

.tl-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #606266;
}

.tl-desc {
  margin-top: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #555555;
  line-height: 25px;
  padding: 10px 12px;
  background: #F7F7F7;
  border-radius: 12px;
  margin-bottom: 24px;
}

.tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.tag {
  display: inline-flex;
  align-items: center;
  width: 83px;
  height: 40px;
  background: #F8F8F8;
  border-radius: 4px;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  justify-content: center;
}

.add-skill {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 520px;
}

.kv-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.kv {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}

.k {
  // width: 92px;
  // font-size: 12px;
}

.v {
  font-size: 14px;
  color: #333333;
  margin-left: 30px;
}

.muted {
  font-size: 12px;
  color: #b0b3b8;
}

.edit-lite {
  max-width: 620px;
}

/* ✅ 图二：编辑态技能标签（浅绿 + 右侧绿色X） */
.skill-selected-row {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  margin-top: 6px;
  margin-bottom: 40px;
}

.skill-selected-label {
  width: 92px;
  padding-top: 10px;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  white-space: nowrap;
}

.skill-selected {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: center;
  min-height: 40px;
}

.skill-chip {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  width: 109px;
  height: 40px;
  background: #F5FFEA;
  border-radius: 4px 4px 4px 4px;
  font-weight: 400;
  font-size: 16px;
  color: #5A9A0E;
  justify-content: center;
  line-height: 1;
}
.skill-chip2 {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  // width: 82px;
  padding:0 20px;
height: 40px;
background: #FFFFFF;
border-radius: 4px 4px 4px 4px;
border: 1px solid #FFFFFF;
font-weight: 400;
font-size: 16px;
color: #616161;
  justify-content: center;
  line-height: 1;
}

.slashlogo {
  width: 16px;
  height: 16px;
}

.skill-chip-x {
  width: 18px;
  height: 18px;
  border-radius: 2px;
  border: 1px solid #4CAF50;
  background: #4CAF50;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
}
</style>